<template>
  <div id="analytic-info" class="content-padding scroll-vertical">
    <content-nav-bar>Analytic Summary</content-nav-bar>
    <detail-item
      name="Name"
      imgName="name">
      {{ analytic.name }}
    </detail-item>
    <detail-item
      name="Description"
      imgName="description">
      {{ analytic.description }}
    </detail-item>
    <detail-item
      v-if="admin"
      name="Released"
      imgName="circle">
      <p v-if="analytic.released" class="level-item">Yes</p>
      <p v-else class="level-item">No</p>
    </detail-item>
    <detail-item
      v-else
      name="Owner"
      imgName="circle">
      <p v-if="analytic.digita" class="level-item">Digita</p>
      <p v-else class="level-item">{{ organization.name }}</p>
    </detail-item>
    <detail-item
      name="Categories"
      imgName="tag">
      <div class="tags">
        <span v-for="cat in analytic.categories" :key="cat" class="tag is-rounded">{{ cat }}</span>
      </div>
    </detail-item>
    <detail-item
      name="Event Type"
      imgName="sensor">
      <div class="level">
        <analytic-event-type-icon :analytic="analytic" class="level-item detail-info">
        </analytic-event-type-icon>
        <p class="level-item">{{ analytic.inputType }}</p>
      </div>
    </detail-item>
    <detail-item
      name="Level"
      imgName="level">
      {{ analytic.level }}
    </detail-item>
    <detail-item
      name="Predicate"
      imgName="logic">
      {{ analytic.filter }}
    </detail-item>
    <detail-item
      name="Created"
      imgName="cal">
      {{ analytic.created | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="Updated"
      imgName="cal">
      {{ analytic.updated | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="Actions"
      imgName="action">
      <div class="tags">
        <span v-for="action in analytic.actions" :key="action" class="tag is-rounded">
          {{ action }}
        </span>
      </div>
    </detail-item>
    <detail-item
      name="Tags"
      imgName="tag">
      <div class="tags">
        <span v-for="tag in analytic.tags" :key="tag" class="tag is-rounded">{{ tag }}</span>
      </div>
    </detail-item>
    <detail-item
      name="Snapshot Files"
      imgName="circle">
      <span v-if="analytic.snapshotFiles">{{ analytic.snapshotFiles.join(', ') }}</span>
      <span v-else>-</span>
    </detail-item>
    <detail-item
        name="Context"
        imgName="circle">
        {{ analytic.context.length }} Items
    </detail-item>
    <div class="context-info" v-for="(item,index) in analytic.context" :key="item.name+index">
        <detail-item
        name="Name"
        imgName="name">
        {{ item.name }}
      </detail-item>
      <detail-item
        name="Type"
        imgName="circle">
        {{ item.type }}
      </detail-item>
      <detail-item
        v-for="(expr,index) in item.exprs"
        :key="expr + index"
        name="Expr"
        imgName="logic">
        {{ expr }}
      </detail-item>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import gmt from '@/mixins/gmt';
import DetailItem from '@/components/DetailItem.vue';
import AnalyticEventTypeIcon from '@/components/analytics/AnalyticEventTypeIcon.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'AnalyticDetails',
  mixins: [gmt],
  components: { DetailItem, AnalyticEventTypeIcon, ContentNavBar },
  computed: {
    ...mapState('primary', ['organization']),
  },
  props: {
    analytic: {
      type: Object,
      required: true,
    },
    admin: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.tags {
  .tag {
    background-color: #789;
  }
}

.wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

img.detail-header {
  height: 50px;
}

img.detail-info {
  height: 35px;
}

.analytic-header {
  border-bottom: 2px solid $font-color;
}

.context-info {
  margin: $form-padding;
  background-color: $form-subitem;
}

.level-right p {
  flex-shrink: 1;
  ext-align: right;
}
.description {
  padding: 15px;
  background-color: $form-subitem;
  margin: 15px 0;
}
</style>
